<template>
  <div class="icon-uploader">
    <div class="iu-preview" :class="{ empty: !modelValue }" @click="trigger">
      <img v-if="modelValue" :data-imagebed-src="modelValue" alt="图标" />
      <span v-else class="iu-plus">+</span>
      <div v-if="uploading" class="iu-mask">上传中…</div>
    </div>
    <div class="iu-side">
      <button type="button" class="iu-btn" :disabled="uploading" @click="trigger">
        {{ modelValue ? '更换图标' : '上传图标' }}
      </button>
      <button v-if="modelValue && !uploading" type="button" class="iu-clear" @click="clear">清除</button>
      <div class="iu-hint">jpg/png/gif/webp，建议方形，≤2MB</div>
    </div>
    <input ref="file" type="file" accept="image/jpeg,image/png,image/gif,image/webp" class="iu-input" @change="onFile" />
  </div>
</template>

<script>
import { uploadImage } from '@/api'
import { useUiStore } from '@/store/ui'

const MAX_SIZE = 2 * 1024 * 1024

export default {
  name: 'IconPicker',
  props: {
    modelValue: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return { ui: useUiStore(), uploading: false }
  },
  methods: {
    trigger() {
      if (this.uploading) return
      this.$refs.file.click()
    },
    async onFile(e) {
      const file = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!file) return
      if (file.size > MAX_SIZE) {
        this.ui.showToast('图标不能超过 2MB', 'error')
        return
      }
      this.uploading = true
      try {
        const res = await uploadImage(file)
        this.$emit('update:modelValue', res.data.url)
      } catch (err) {
        this.ui.showToast(err.message || '上传失败', 'error')
      } finally {
        this.uploading = false
      }
    },
    clear() {
      this.$emit('update:modelValue', '')
    },
  },
}
</script>

<style scoped>
.icon-uploader { display: flex; align-items: center; gap: 12px; }
.iu-preview {
  position: relative; width: 56px; height: 56px; flex-shrink: 0;
  border-radius: var(--radius-sm); overflow: hidden; cursor: pointer;
  border: 1px solid var(--border-strong); background: var(--surface-2);
  display: grid; place-items: center;
}
.iu-preview.empty { border-style: dashed; }
.iu-preview img { width: 100%; height: 100%; object-fit: cover; }
.iu-plus { font-size: 26px; color: var(--text-3); line-height: 1; }
.iu-mask { position: absolute; inset: 0; background: rgba(0,0,0,.5); color: #fff; font-size: 12px; display: grid; place-items: center; }
.iu-side { display: flex; flex-direction: column; gap: 4px; align-items: flex-start; }
.iu-btn { height: 32px; padding: 0 12px; border: 1px solid var(--border-strong); border-radius: var(--radius-sm); font-size: 13px; color: var(--text); background: var(--surface); cursor: pointer; }
.iu-btn:hover { border-color: var(--primary); color: var(--primary); }
.iu-btn:disabled { opacity: .6; cursor: default; }
.iu-clear { font-size: 12px; color: var(--text-3); }
.iu-clear:hover { color: var(--danger); }
.iu-hint { font-size: 11px; color: var(--text-3); }
.iu-input { display: none; }
</style>
